import React, { useLayoutEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import './VideoPlayer.css';

const VideoPlayer = ({ videoSrc, id, className, controls = true, autoplay = false, muted = false, preload = "auto" }) => {
  const containerRef = useRef(null);
  const playerRef = useRef(null);

  useLayoutEffect(() => {
    // Check if the container is in the DOM and Video.js player isn't initialized
    if (containerRef.current && !playerRef.current) {
      // Create a video element manually
      const videoElement = document.createElement('video');
      videoElement.className = `video-js vjs-default-skin ${className}`;
      videoElement.setAttribute('playsinline', 'true');

      // Append the video element to the container
      containerRef.current.appendChild(videoElement);

      // Initialize Video.js on the newly created video element
      playerRef.current = videojs(videoElement, {
        controls: controls,
        autoplay: autoplay,
        muted: muted,
        preload: preload,
        sources: [{ src: videoSrc, type: 'video/mp4' }],
        
      });
    }

    // Cleanup on unmount
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [videoSrc]); // Re-run effect when videoSrc changes

  return (
    <div className="video-container" ref={containerRef} />
  );
};

export default VideoPlayer;
